import {createContext, Context} from 'solid-js'
import { I18nProviderBehavior } from './I18nProvider'

export const I18nProviderContext: Context<I18nProviderBehavior> = createContext({
    getI18n:  () => undefined,
})
